export enum AutoGeneratedMessageEnum {
    CallStarted = 1,
    CallEnded = 2,
    MissedVideoCall = 3,
    MissedCall = 4,
    ParticipantAdded = 5,
    CallDeclined = 6,
    ParticipantLeft = 7,
    GroupNameChange = 8,
    MeetingStarted = 9,
    MeetingEnded = 10
}
